// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panel[class*=theme-][data-v-72ccc97b]{overflow:hidden}.container[data-v-72ccc97b]{position:relative}.key[data-v-72ccc97b]{border:1px solid #455fed;padding:3rem 0}.subtitle[data-v-72ccc97b]{color:#455fed;line-height:1.2;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
